import React from 'react';

import SummaryGridField from 'components/atoms/summary_grid_field';

interface BiddingSummaryTwoColumnGridProps {
  rows: { label: string; value: string }[];
  emptyLabel?: string;
}

const BiddingSummaryTwoColumnGrid: React.FC<BiddingSummaryTwoColumnGridProps> = ({
  rows,
  emptyLabel = 'Não informado',
}) => {
  if (rows.length === 0) return <p className="mb-0 text-muted">{emptyLabel}</p>;
  const mid = Math.ceil(rows.length / 2);
  const left = rows.slice(0, mid);
  const right = rows.slice(mid);
  return (
    <div className="row">
      <div className="col-md-6">
        {left.map((r) => (
          <SummaryGridField key={r.label} label={r.label} value={r.value} />
        ))}
      </div>
      <div className="col-md-6">
        {right.map((r) => (
          <SummaryGridField key={r.label} label={r.label} value={r.value} />
        ))}
      </div>
    </div>
  );
};

export default BiddingSummaryTwoColumnGrid;
